import { render, staticRenderFns } from "./FileStoreFile.vue?vue&type=template&id=d0c7eca0&scoped=true&lang=pug&"
import script from "./FileStoreFile.vue?vue&type=script&lang=js&"
export * from "./FileStoreFile.vue?vue&type=script&lang=js&"
import style0 from "./FileStoreFile.vue?vue&type=style&index=0&id=d0c7eca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c7eca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
